export type TQuarterId = number;

export interface Quarter {
  id: TQuarterId;
  reporting_quarter: string;
}
